<template lang="pug">
  div.hamburger
    //- Lines
    div.hamburger__line.hamburger__line--01
      div.hamburger__line-in.hamburger__line-in--01
    div.hamburger__line.hamburger__line--02
      div.hamburger__line-in.hamburger__line-in--02
    div.hamburger__line.hamburger__line--03
      div.hamburger__line-in.hamburger__line-in--03
    //- Cross
    div.hamburger__line.hamburger__line--cross01
      div.hamburger__line-in.hamburger__line-in--cross01
    div.hamburger__line.hamburger__line--cross02
      div.hamburger__line-in.hamburger__line-in--cross02
</template>


<script>
export default {
  name: 'hamburger-menu'
}
</script>


<style lang="sass" scoped>
  // Hamburger Menu
  .hamburger
    width: 64px
    height: 64px
    display: block
    position: fixed
    cursor: pointer
    top: 2.25em
    right: 2.25em
    z-index: 110
    pointer-events: auto
    -webkit-tap-highlight-color: rgba(0,0,0,0)
    animation: fadeInDown .7s both
    animation-delay: 4.5s
    top: 2.5em
    right: -1.5em
    transform: scale(0.75)
    @media screen and (min-width: 768px)
      top: 4.25em
      right: 0.25em

    &__line
      width: 28px
      height: 2px
      overflow: hidden
      position: absolute
      z-index: 10
      transition-duration: 0.6s
      transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1)
      &--01, &--02, &--03
        left: 18px
      &--01
        top: 24.6px
      &--02
        top: 31px
      &--03
        top: 37.4px
      &--cross01, &--cross02
        left: 18px
        top: 31px
      &--cross01
        transform: rotate(45deg)
      &--cross02
        transform: rotate(-45deg)

    &__line-in
      width: 84px
      height: 2px
      position: absolute
      top: 0
      left: 0
      transition-duration: 0.6s
      transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1)
      &:before, &:after
        width: 28px
        height: 2px
        content: ''
        display: block
        position: absolute
        top: 0
        background-color: #ffffff
        transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1)
        transition-property: transform
      &:before
        left: -56px
      &:after
        left: 0
      &--01
        transition-delay: 0.2s
      &--02
        transition-delay: 0.25s
        &:before, &:after
          transition-delay: 0.05s
      &--03
        transition-delay: 0.3s
        &:before, &:after
          transition-delay: 0.1s
      &--cross01, &--cross02
        transform: translateX(-33.3%)
      &--cross01
        transition-delay: 0s
      &--cross02
        transition-delay: 0.05s
        &:before, &:after
          transition-delay: 0.1s

    &:hover
      .hamburger__line-in
        &:before, &:after
          transform: translateX(200%)
        &--01, &--02, &--03
          &:before, &:after
            transition-duration: 1s
        &--cross01, &--cross02
          &:before, &:after
            transition-duration: 0s

    // Opened navigation
    &.is-opened-navi
      .hamburger__line-in
        &--01, &--02, &--03
          transform: translateX(33.3%)
        &--01
          transition-delay: 0s
        &--02
          transition-delay: 0.05s
        &--03
          transition-delay: 0.1s
        &--cross01, &--cross02
          transform: translateX(0)
        &--cross01
          transition-delay: 0.25s
        &--cross02
          transition-delay: 0.3s
      &:hover
        .hamburger__line-in
          &--01, &--02, &--03
            &:before, &:after
              transition-duration: 0s
          &--cross01, &--cross02
            &:before, &:after
              transition-duration: 1s
</style>



// WEBPACK FOOTER //
// src/components/HamburgerMenu.vue